var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inner-body p20"},[_c('qrcode-stream',{attrs:{"camera":_vm.camera},on:{"decode":_vm.decodeQR}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }